/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getWeatherForecast$Json } from '../fn/weather-forecast/get-weather-forecast-json';
import { GetWeatherForecast$Json$Params } from '../fn/weather-forecast/get-weather-forecast-json';
import { getWeatherForecast$Plain } from '../fn/weather-forecast/get-weather-forecast-plain';
import { GetWeatherForecast$Plain$Params } from '../fn/weather-forecast/get-weather-forecast-plain';
import { WeatherForecast } from '../models/weather-forecast';
import { weatherForecastSeedGet$Json } from '../fn/weather-forecast/weather-forecast-seed-get-json';
import { WeatherForecastSeedGet$Json$Params } from '../fn/weather-forecast/weather-forecast-seed-get-json';
import { weatherForecastSeedGet$Plain } from '../fn/weather-forecast/weather-forecast-seed-get-plain';
import { WeatherForecastSeedGet$Plain$Params } from '../fn/weather-forecast/weather-forecast-seed-get-plain';
import { WebhookEndpointDto } from '../models/webhook-endpoint-dto';

@Injectable({ providedIn: 'root' })
export class WeatherForecastApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getWeatherForecast()` */
  static readonly GetWeatherForecastPath = '/WeatherForecast';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getWeatherForecast$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWeatherForecast$Plain$Response(params?: GetWeatherForecast$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<WeatherForecast>>> {
    const obs = getWeatherForecast$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getWeatherForecast$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWeatherForecast$Plain(params?: GetWeatherForecast$Plain$Params, context?: HttpContext): Observable<Array<WeatherForecast>> {
    const resp = this.getWeatherForecast$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<WeatherForecast>>): Array<WeatherForecast> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getWeatherForecast$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWeatherForecast$Json$Response(params?: GetWeatherForecast$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<WeatherForecast>>> {
    const obs = getWeatherForecast$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getWeatherForecast$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWeatherForecast$Json(params?: GetWeatherForecast$Json$Params, context?: HttpContext): Observable<Array<WeatherForecast>> {
    const resp = this.getWeatherForecast$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<WeatherForecast>>): Array<WeatherForecast> => r.body)
    );
  }

  /** Path part for operation `weatherForecastSeedGet()` */
  static readonly WeatherForecastSeedGetPath = '/WeatherForecast/seed';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `weatherForecastSeedGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  weatherForecastSeedGet$Plain$Response(params?: WeatherForecastSeedGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<WebhookEndpointDto>>> {
    const obs = weatherForecastSeedGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `weatherForecastSeedGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  weatherForecastSeedGet$Plain(params?: WeatherForecastSeedGet$Plain$Params, context?: HttpContext): Observable<Array<WebhookEndpointDto>> {
    const resp = this.weatherForecastSeedGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<WebhookEndpointDto>>): Array<WebhookEndpointDto> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `weatherForecastSeedGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  weatherForecastSeedGet$Json$Response(params?: WeatherForecastSeedGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<WebhookEndpointDto>>> {
    const obs = weatherForecastSeedGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `weatherForecastSeedGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  weatherForecastSeedGet$Json(params?: WeatherForecastSeedGet$Json$Params, context?: HttpContext): Observable<Array<WebhookEndpointDto>> {
    const resp = this.weatherForecastSeedGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<WebhookEndpointDto>>): Array<WebhookEndpointDto> => r.body)
    );
  }

}
